import React, { useState, useEffect, useContext } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import Card from "react-bootstrap/Card";
import LastActivatedPos from "./LastActivatedPos";
import LastActivatedUser from "./LastActivatedUser";
import LastAddedTenant from "./LastAddedTenant";
import NumberOfActivePos from "./NumberOfActivePos";
import TotalNumberOfTenants from "./TotalNumberOfTenants";
import TotalNumberOfUsers from "./TotalNumberOfUsers";
import TransactionsPerMonth from "./TransactionsPerMonth";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services/global.service";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";

const DashboardLayoutStatistics = (props) => {
  const { updatePerformances } = useContext(GlobalContext);
  const ResponsiveGridLayout = WidthProvider(Responsive);

  const onLayoutChange = (layout, layouts) => {
    saveToLocalStorage("layouts", layouts);
  };

  const [widgets, setWidgets] = useState(null);

  useEffect(() => {
    globalServices
      .getAllWidgetsStat()
      .then((res) => {
        setWidgets({
          lastActivatedPos: res.data.data[0].isActive,
          lastActivatedUser: res.data.data[1].isActive,
          lastAddedTenant: res.data.data[2].isActive,
          numberOfActivePos: res.data.data[3].isActive,
          totalNumberOfTenants: res.data.data[4].isActive,
          totalNumberOfUsers: res.data.data[5].isActive,
          transactionsPerMonth: res.data.data[6].isActive,
        });
      })
      .catch((err) => console.log(err.response));
  }, [updatePerformances]);

  const saveToLocalStorage = (key, value) => {
    if (global.localStorage) {
      global.localStorage.setItem(
        "cardsOrderStatistics",
        JSON.stringify({
          [key]: value,
        })
      );
    }
  };

  for (let t = 0; t <= 300; t += 10) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, t);
  }

  const loadFromLocalStorage = (key) => {
    let localStorage = {};
    if (global.localStorage) {
      try {
        localStorage =
          JSON.parse(global.localStorage.getItem("cardsOrderStatistics")) || {};
      } catch (e) {
        // ignore for now
      }
    }
    return localStorage["layouts"];
  };

  const originalLayouts = JSON.parse(
    JSON.stringify(loadFromLocalStorage("cardsOrderStatistics") || {})
  );
  const [layouts, setLayouts] = useState(originalLayouts);

  return (
    <>
      {widgets && (
        <ResponsiveGridLayout
          className="layout"
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={150}
          layouts={layouts}
          width={1200}
          isDraggable={true}
          isResizable={false}
          onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
        >
          <Card
            hidden={widgets && !widgets.totalNumberOfTenants}
            key={"totalNumberOfTenants"}
            data-grid={{ x: 0, y: 0, w: 3, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
            <TotalNumberOfTenants />
          </Card>

          <Card
            hidden={widgets && !widgets.totalNumberOfUsers}
            key={"totalNumberOfUsers"}
            data-grid={{ x: 3, y: 0, w: 3, h: 2 }}
            className="text-center dashboard dashboard-user-data"
          >
            <TotalNumberOfUsers />
          </Card>

          <Card
            hidden={widgets && !widgets.numberOfActivePos}
            key={"numberOfActivePos"}
            data-grid={{ x: 6, y: 2, w: 3, h: 2 }}
            className="text-center dashboard dashboard-pos-data"
          >
            <NumberOfActivePos />
          </Card>

          <Card
            hidden={widgets && !widgets.lastActivatedPos}
            key={"lastActivatedPos"}
            data-grid={{ x: 9, y: 2, w: 3, h: 2 }}
            className="text-center dashboard dashboard-pos-data"
          >
            <LastActivatedPos />
          </Card>

          <Card
            hidden={widgets && !widgets.lastAddedTenant}
            key={"lastAddedTenant"}
            data-grid={{ x: 0, y: 2, w: 3, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
            <LastAddedTenant />
          </Card>

          <Card
            hidden={widgets && !widgets.lastActivatedUser}
            key={"lastActivatedUser"}
            data-grid={{ x: 3, y: 2, w: 3, h: 2 }}
            className="text-center dashboard dashboard-user-data"
          >
            <LastActivatedUser />
          </Card>

          <Card
            hidden={widgets && !widgets.transactionsPerMonth}
            key={"transactionsPerMonth"}
            data-grid={{ x: 6, y: 4, w: 6, h: 2 }}
            className="text-center dashboard"
          >
            <TransactionsPerMonth />
          </Card>
        </ResponsiveGridLayout>
      )}
    </>
  );
};

export default DashboardLayoutStatistics;
